import axios from 'axios'
import MD5 from 'crypto-js/md5'
import JSEncrypting from 'jsencrypt'
import router from '@/router'
import { Toast } from 'vant'
import { PUBLIC_KEY, PRIVATE_KEY } from '@/constants'
import {isIos, isAndroid, isWeiXin, isAliPay} from '@/utils/index'
import store from '../store'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
})

//请求拦截
service.interceptors.request.use(config => {
    const { sessionId = '' } = router.history.current.query,
        {method='',data = {}} = config
    if (sessionId) {
      config.headers.Session = sessionId
    }
    if (method === 'post') {
      data['timestamp'] = Date.now()
      const signString = objectToString(data)
      const obcSign = MD5(signString).toString()
      console.log(config.url,JSON.stringify(data))
      if (config['encrypt']) {
        const encryptData = $encrypt(encodeURIComponent(JSON.stringify(data)))
        config.data = { data: encryptData }
      } else {
        config.data = data
      }
      config.headers.Access = obcSign
      delete config['encrypt']
    }
    return config
  }, error => {
    return Promise.reject(error)
  })

//响应拦截
service.interceptors.response.use(res => {
    if (isObject(res.data) && Object.keys(res.data).length === 1 && typeof res.data.data === 'string') {
      const decryptData = $decrypt(res.data.data)
      res.data = decryptData ? JSON.parse(decodeURIComponent(decryptData)) : {}
    }
    let { data: {ok = true,status = '000000',data = '',message = ''} } = res
    if(ok && status === '000000'){
      return data
    }else{
      if(status === '701'){
        Toast({
          message,
          forbidClick: true,
          onClose(){
            if(isAndroid || isIos){
              if(isIos){
                window.webkit.messageHandlers.nativeCall.postMessage({
                  type: 'backClassify'
                })
              }else{
                window.android.nativeCall(JSON.stringify({type: 'backClassify'}))
              }
            }else if(isWeiXin || isAliPay){
              if(isWeiXin){
                window.wx.miniProgram.navigateBack()
              }else{
                window.my.navigateBack()
              }
            }else{
              store.dispatch('emitShowLogin',{status: true}).then(()=>{})
            }
          }
        })
      }else{
        return Promise.reject(res.data)
      }
    }
  }, error => {
    Toast(error.message)
    return Promise.reject(error)
  })

/**
 * 对象转为字符串
 */
function tagTester(name) {
  const tag = '[object ' + name + ']'
  return function (obj) {
    return Object.prototype.toString.call(obj) === tag
  }
}
function isArray(obj) {
  return Array.isArray(obj) || tagTester('Array')(obj)
}
function isObject(obj) {
  return typeof obj === 'object' && !!obj && !isArray(obj)
}
function isPrime(value) {
  return !isObject(value) && !isArray(value) && value != null && value !== ''
}
function objectToString(data, ignore) {
  if (!isObject(data)) return ''
  const keys = Object.keys(data).sort()
  const demoString = []
  keys.forEach((item) => {
    const value = data[item]
    if (isObject(value) && !ignore) {
      demoString.push(item + '=' + objectToString(value, true))
    } else if (isPrime(value)) {
      demoString.push(item + '=' + (value + ''))
    }
  })
  return demoString.join('&')
}

/**
 * JSEncrypt充长文本加解密：decryptLong，encryptLong
 */
class JSEncryptNEW extends JSEncrypting {
  // private b64map;
  // private readonly b64pad;
  // private BI_RM;
  constructor() {
    super()
    this.b64map =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    this.b64pad = '='
    this.BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz'
  }
  int2char(n) {
    return this.BI_RM.charAt(n)
  }
  b64tohex(s) {
    let ret = ''
    let i
    let k = 0 // b64 state, 0-3
    let slop = 0
    for (i = 0; i < s.length; ++i) {
      if (s.charAt(i) === this.b64pad) {
        break
      }
      let v = this.b64map.indexOf(s.charAt(i))
      if (v < 0) {
        continue
      }
      if (k === 0) {
        ret += this.int2char(v >> 2)
        slop = v & 3
        k = 1
      } else if (k === 1) {
        ret += this.int2char((slop << 2) | (v >> 4))
        slop = v & 0xf
        k = 2
      } else if (k === 2) {
        ret += this.int2char(slop)
        ret += this.int2char(v >> 2)
        slop = v & 3
        k = 3
      } else {
        ret += this.int2char((slop << 2) | (v >> 4))
        ret += this.int2char(v & 0xf)
        k = 0
      }
    }
    if (k === 1) {
      ret += this.int2char(slop << 2)
    }
    return ret
  }
  hex2b64(h) {
    let i
    let c
    let ret = ''
    for (i = 0; i + 3 <= h.length; i += 3) {
      c = parseInt(h.substring(i, i + 3), 16)
      ret += this.b64map.charAt(c >> 6) + this.b64map.charAt(c & 63)
    }
    if (i + 1 === h.length) {
      c = parseInt(h.substring(i, i + 1), 16)
      ret += this.b64map.charAt(c << 2)
    } else if (i + 2 === h.length) {
      c = parseInt(h.substring(i, i + 2), 16)
      ret += this.b64map.charAt(c >> 2) + this.b64map.charAt((c & 3) << 4)
    }
    while ((ret.length & 3) > 0) {
      ret += this.b64pad
    }
    return ret
  }
  // 分段加密
  encryptLong(string) {
    const k = this.getKey()
    //根据key所能编码的最大长度来定分段长度。key size - 11：11字节随机padding使每次加密结果都不同。
    // @ts-ignore
    const maxLength = ((k.n.bitLength() + 7) >> 3) - 12
    try {
      let subStr = '',
        encryptedString = ''
      let subStart = 0,
        subEnd = 0
      let bitLen = 0,
        tmpPoint = 0
      let len = string.length
      for (let i = 0; i < len; i++) {
        //js 是使用 Unicode 编码的，每个字符所占用的字节数不同
        const charCode = string.charCodeAt(i)
        if (charCode <= 0x007f) {
          bitLen += 1
        } else if (charCode <= 0x07ff) {
          bitLen += 2
        } else if (charCode <= 0xffff) {
          bitLen += 3
        } else {
          bitLen += 4
        }
        //字节数到达上限，获取子字符串加密并追加到总字符串后。更新下一个字符串起始位置及字节计算。
        if (bitLen > maxLength) {
          subStr = string.substring(subStart, subEnd)
          encryptedString += k.encrypt(subStr)
          subStart = subEnd
          bitLen = bitLen - tmpPoint
        } else {
          subEnd = i
          tmpPoint = bitLen
        }
      }
      subStr = string.substring(subStart, len)
      encryptedString += k.encrypt(subStr)
      return this.hex2b64(encryptedString)
    } catch (ex) {
      return false
    }
  }
  // 分段解密
  decryptLong(string) {
    const k = this.getKey()
    //解密长度=key size.hex2b64结果是每字节每两字符，所以直接*2
    // @ts-ignore
    const maxLength = ((k.n.bitLength() + 7) >> 3) * 2
    try {
      const hexString = this.b64tohex(string)
      let decryptedString = ''
      const rexStr = '.{1,' + maxLength + '}'
      const rex = new RegExp(rexStr, 'g')
      const subStrArray = hexString.match(rex)
      if (subStrArray) {
        subStrArray.forEach(function (entry) {
          decryptedString += k.decrypt(entry)
        })
        return decryptedString
      }
    } catch (ex) {
      return false
    }
  }
}
export function $encrypt(str, publicKey = PUBLIC_KEY) {
  const ENCRYPT = new JSEncryptNEW()
  ENCRYPT.setPublicKey(publicKey)
  return ENCRYPT.encryptLong(str)
}
export function $decrypt(str, privateKey = PRIVATE_KEY) {
  const ENCRYPT = new JSEncryptNEW()
  ENCRYPT.setPrivateKey(privateKey)
  return ENCRYPT.decryptLong(str)
}

export default service
